<div *ngIf="!onlineOffline || socketDisconneted" class="offline">
    <span>
        <mat-icon class="offline--icon">wifi_off</mat-icon>
        {{socketDisconneted ? "A função de atualização automática está fora do ar." : "Você esta sem conexão com a
        internet no momento."}}
    </span>
</div>

<div class="main-content" [ngClass]="{'content-padding-top': !onlineOffline || socketDisconneted}">

    <div class="video-column overflow-screen video-player">
        <div *ngIf="mediaDisplay" class="video-container">
            <app-media-display [mediaSources]="mediaSources" [refreshTime]="mediaSourceExpirationTime"
                (refresh)="getCampaignMedia()"></app-media-display>
        </div>
    </div>

    <div class="history-column">
        <div class="justify-right">
            <span class="title-txt">ÚLTIMOS CHAMADOS:</span>
        </div>

        <div *ngIf="mainClient != null" class="history-content">
            <div class="client-info">
                <span class="client-info__name">
                    Senha <b>{{mainClient.ticket}}</b>
                </span>
                <span *ngIf="mainClient.namePacient != null" class="client-info__bar">|</span>
                <span *ngIf="mainClient.namePacient != null" class="text-info-color">
                    {{mainClient.namePacient}}
                </span>
            </div>
            <span class="sector-info">
                {{ mainClient?.nameSector + ' ' + mainClient?.nameRoom}}
            </span>
        </div>

        <div class="history-list">
            <div *ngFor="let client of historicalList; let i=index" class="call history-call">
                <div *ngIf="client.ticket != null" class="history-content-client">
                    <div class="client-info">
                        <span class="client-info__name">
                            Senha <b>{{client.ticket}}</b>
                        </span>
                        <span *ngIf="client.namePacient != null" class="client-info__bar">|</span>
                        <span *ngIf="client.namePacient != null" class="text-info-color">
                            {{client.namePacient}}
                        </span>
                    </div>
                    <span class="sector-info">
                        {{ client?.nameSector + ' ' + client?.nameRoom}}
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>

<footer class="footer-bar">
    <div class="footer-logos">
        <img *ngIf="this.sanitezedLogo" class="brand" [src]="this.sanitezedLogo">
        <img class="brand" src="assets/images/logo-branco.png">
        <span *ngIf="showAverageWaitingTime" class="personalized-waiting-hours">
            <span class="vertical-line"></span>
            MÉDIA DE ESPERA - TRIAGEM: {{lastHourWaitingTimeAverage}}
            <span class="text-last-hour">(última hora)</span>
        </span>
    </div>
    <div class="info">
        <span class="date-time">
            <mat-icon>calendar_today</mat-icon>{{date}}
        </span>
        <span class="date-time">
            <mat-icon>schedule</mat-icon>{{time}}
        </span>
    </div>
</footer>